import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useMediaQuery } from 'usehooks-ts';

const Footer = () => {
const mobile = useMediaQuery("(max-width: 767px)");
  const navigate=useNavigate()
      const handleScroll = (id) => {
    const section = document.getElementById(id);
    if (section) {
      section.scrollIntoView({ behavior: "smooth", block: "start" });
    }
   
    
  };
  return (
    <div className='footer'>

       {mobile? 
       <div style={{display:"flex",alignItems:"start",justifyContent:"space-between", listStyle:"none"}}>
           <div style={{width:"40%"}}>
             <div className="logo" onClick={() =>navigate("/")}
          style={{display:"flex",alignItems:"center",gap:"10px",paddingLeft:mobile?"2px":"20px"}}
          >
         {!mobile && <img src="/Assets/title-logo.png" style={{width:"140px",height:"136px"}}/>}
          <img src="/Assets/logo.png" style={{width:"100%",height:mobile?"30px":"30px"}}/>
        </div>
        <p style={{textAlign:"left",fontSize:"10px"}}>
          ROAMJSSLN PVT LTD is a growing online bus ticket booking platform built to make travel simple, safe, and convenient. We offer easy bus ticket booking through our website and mobile apps, connecting passengers with major routes across the country.
        </p>
            </div>

            <div>
                <ul style={{listStyle:"none",display:"flex",flexDirection:"column",alignItems:"start"}}>
                    <li style={{fontSize:"10px",fontWeight:"700",paddingBottom:"20px",cursor:"pointer"}}>About ROAMJSSLN PVT LTD</li>
                    <li style={{fontSize:"8px",fontWeight:700,color:"blue",paddingBottom:"20px",cursor:"pointer"}}>
                        <a href='' style={{textDecoration:"none",color:"gray"}}
                        onClick={() => handleScroll("about")}>Read we</a></li>
                      <li style={{fontSize:"8px",fontWeight:700,color:"blue",paddingBottom:"20px",cursor:"pointer"}}> 
                          <a href='' style={{textDecoration:"none",color:"gray"}}
                          onClick={() => handleScroll("workings")}>How we work</a></li>
                        <li style={{fontSize:"8px",fontWeight:700,color:"blue",paddingBottom:"20px",cursor:"pointer"}}>
                            <a href='' style={{textDecoration:"none",color:"gray"}}
                            onClick={() => handleScroll("deals")}>Offers</a> </li>
                        
                </ul>
            </div>
            <div>
                <ul style={{listStyle:"none",display:"flex",flexDirection:"column",alignItems:"start"}}>
                    <li style={{fontSize:"10px",fontWeight:"700",paddingBottom:"20px"}}>Info</li>
                      <li style={{fontSize:"8px",fontWeight:700,color:"blue",paddingBottom:"20px",cursor:"pointer"}}>
                         <a href='/termscondition' style={{textDecoration:"none",color:"gray"}}>Terms & Condition</a>
                      </li>
                        <li style={{fontSize:"8px",fontWeight:700,color:"blue",paddingBottom:"20px",cursor:"pointer"}}>
                             <a href='/privacypolicy' style={{textDecoration:"none",color:"gray"}}>Privacy policy</a>
                        </li>
                          <li style={{fontSize:"8px",fontWeight:700,color:"blue",paddingBottom:"20px",cursor:"pointer"}}>Blogs</li>

                                    <li style={{fontSize:"8px",fontWeight:700,color:"blue",paddingBottom:"20px",cursor:"pointer"}}>Bus timetable</li>
            
                                       
                </ul>
            </div>
          

        </div>

        :
        <div style={{display:"flex",alignItems:"start",justifyContent:"space-between", listStyle:"none"}}>
           <div style={{width:"30%"}}>
             <div className="logo" onClick={() =>navigate("/")}
          style={{display:"flex",alignItems:"center",gap:"10px",paddingLeft:mobile?"2px":"20px"}}
          >
         {!mobile && <img src="/Assets/title-logo.png" style={{width:"140px",height:"136px"}}/>}
          <img src="/Assets/logo.png" style={{width:"100%",height:mobile?"60px":"60px"}}/>
        </div>
        <p style={{textAlign:"left"}}>
          ROAMJSSLN PVT LTD is a growing online bus ticket booking platform built to make travel simple, safe, and convenient. We offer easy bus ticket booking through our website and mobile apps, connecting passengers with major routes across the country.
        </p>
            </div>
            <div>
                <ul style={{listStyle:"none",display:"flex",flexDirection:"column",alignItems:"start"}}>
                    <li style={{fontSize:"18px",fontWeight:"700",paddingBottom:"20px",cursor:"pointer"}}>About Us</li>
                    <li style={{fontSize:"16px",fontWeight:200,color:"blue",paddingBottom:"20px",cursor:"pointer"}}>
                        <a  style={{textDecoration:"none",color:"gray"}}
                          onClick={() => handleScroll("about")}>Read us</a></li>
                      <li style={{fontSize:"16px",fontWeight:200,color:"blue",paddingBottom:"20px",cursor:"pointer"}}> 
                          <a  style={{textDecoration:"none",color:"gray"}}
                            onClick={() => handleScroll("workings")}>How we work</a></li>
                        <li style={{fontSize:"16px",fontWeight:200,color:"blue",paddingBottom:"20px",cursor:"pointer"}}>
                            <a  style={{textDecoration:"none",color:"gray"}}
                             onClick={() => handleScroll("deals")}>Offers</a> </li>
                        
                </ul>
            </div>
            <div>
                <ul style={{listStyle:"none",display:"flex",flexDirection:"column",alignItems:"start"}}>
                    <li style={{fontSize:"18px",fontWeight:"700",paddingBottom:"20px"}}>Info</li>
                      <li style={{fontSize:"16px",fontWeight:200,color:"gray",paddingBottom:"20px",cursor:"pointer",textDecoration:"none"}}>
                        <a href='/termscondition' style={{textDecoration:"none",color:"gray"}}>Terms & Condition</a></li>
                        <li style={{fontSize:"16px",fontWeight:200,color:"gray",paddingBottom:"20px",cursor:"pointer"}}>
                          <a href='/privacypolicy' style={{textDecoration:"none",color:"gray"}}>Privacy policy</a></li>
                      

         

                                       
                </ul>
            </div>
          

        </div>
}

        <div>
            
    <div style={{display:'flex',alignItems:"center",justifyContent:"space-between",borderTop:"1px solid gray",paddingTop:"30px",marginTop:"20px"}}>
        <p>© 2026 ROAMJSSLN PVT LTD. All rights reserved.</p>
        <div style={{display:"flex",gap:"10px",alignItems:"center"}}>
            <img src='/Assets/facebook.png'
            style={{width:"30px",height:"30px"}}
            />
             <img src='/Assets/instagram.png'
              style={{width:"30px",height:"30px"}}/>
              <img src='/Assets/linkedin.png'
               style={{width:"30px",height:"30px"}}/>
               <img src='/Assets/twitter.png'
                style={{width:"30px",height:"30px"}}/>
              
        </div>
    </div>
        </div>
        
      
    </div>
  )
}

export default Footer
